import { clsx } from 'clsx';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { twMerge } from 'tailwind-merge';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

const twConfig = resolveConfig(tailwindConfig);

export const randomId = () => {
  return Math.random().toString(32).slice(2);
};

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const devOrProd = process.env.REACT_APP_DEVORPROD;

export const isDev = devOrProd === 'dev';

export const nuqliumDataIndexSeven = () => {
  if (devOrProd === 'dev') {
    return '100042';
  }
  if (devOrProd === 'prod') {
    return '100052';
  }
};

// NQ API - Client ID
export const clientId = '2416ab2a-869d-4b5a-bd56-ce0f04e20694';

// NQ API - Get the correct Nuqlium index based on environment
export const getNuqliumIndex = () => {
  if (devOrProd === 'dev') {
    return '109gxho7fd';
  }
  if (devOrProd === 'prod') {
    return 'k6mro0ewb9';
  }
};

// NQ API - Generate a UUID
function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const getFormData = (object) => {
  // Add required objects to payload
  object.clientid = clientId; // From environment variable
  // Add tracking object and flatten
  const tracking = { userid: getUser() };
  object.tracking = tracking;
  Object.keys(tracking).forEach((key) => {
    object[`tracking[${key}]`] = tracking[key];
  });
  //const userId = getUser();
  //object['tracking[userid]'] = userId;
  //console.log('tracking[userid]', userId);
  // Add sources object and flatten
  const sources = getSources();
  object.sources = sources;
  if (sources && typeof sources === 'object') {
    Object.keys(sources).forEach((key) => {
      object[`sources[${key}]`] = sources[key];
    });
  }
  object.pageinstance = uuidv4(); // New page instance for each request
  object.instance = window.nqInstance++;
  delete object.tracking;
  delete object.sources;
  return object;
};

// NQ API - Gets the user from the cookie, if it doesn't exist, then create a new user
const getUser = () => {
  if (typeof document !== 'undefined') {
    try {
      let nameEQ = 'nqcore=';
      for (let c of document.cookie.split(';')) {
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
          let finalCookie = c.substring(nameEQ.length, c.length);
          finalCookie = window.atob(finalCookie);
          // Guarantee plain string: if JSON, parse and extract userid
          try {
            const parsed = JSON.parse(finalCookie);
            if (parsed && typeof parsed.userid === 'string') {
              return parsed.userid;
            }
          } catch (e) {}
          // Otherwise, return as is
          return finalCookie;
        }
      }
    } catch (err) {}
    // Not found, set new cookie
    let user = uuidv4();
    let expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    let cookieString =
      'nqcore=' +
      window.btoa(user) +
      ';expires=' +
      expires.toUTCString() +
      '; path=/;SameSite=Strict';
    // Only set secure if HTTPS
    if (window.location.protocol === 'https:') {
      cookieString += ';secure';
    }
    document.cookie = cookieString;
    return user;
  }
  // Fallback for non-browser
  return uuidv4();
};

// NQ API - Get sources from session storage. Library can be expanded to add sources if required (search, listings)
const getSources = () => {
  let sources = {};
  let text = window.sessionStorage.getItem('nuqlium.sources');
  if (text) {
    sources = JSON.parse(text);
  }
  return sources;
};

export const renderHTML = (rawHTML, className = null) => {
  // Render HTML in JSON
  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: rawHTML }} />
  );
};

export const renderHTMLspan = (rawHTML, className = null) => {
  // Render HTML in JSON
  return (
    <span className={className} dangerouslySetInnerHTML={{ __html: rawHTML }} />
  );
};

// const getCookieValue = (a) => {
//   var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
//   return b ? b.pop() : '';
// };

export const getInternationalPriceNuqlium = () => {
  // eslint-disable-next-line no-undef
  if (typeof nqDataLayer !== 'undefined') return nqDataLayer.pricelist;
  else return 'retail_gbp';
  // switch (getCookieValue('currencypref')) {
  //   case 'GBP':
  //     return 'retail_gbp';
  //   case 'EUR':
  //     return 'retail_eur';
  //   case 'USD':
  //     return 'retail_usd';
  //   case 'AUD':
  //     return 'retail_aud';
  //   case 'JPY':
  //     return 'retail_jpy';
  //   case 'CNY':
  //     return 'retail_cny';
  //   case 'HKD':
  //     return 'retail_hkd';
  //   default:
  //     return 'retail_gbp';
  // }
};

export const swapImg = (imgPath, fromSize, toSize) => {
  return imgPath.replace(fromSize, toSize);
};

export const randomString = () => {
  return Math.random().toString(36).substring(7);
};

export const getBreakpoint = (query) => {
  return parseInt(twConfig.theme.screens[query].replace('px', ''));
};

export const getPreviousBreakpoint = (query) => {
  const keys = Object.keys(twConfig.theme.screens);
  if (query === 'sm') return 0;
  const prevBreakpoint = keys[keys.indexOf(query) - 1];
  return getBreakpoint(prevBreakpoint);
};

export const getNextBreakpoint = (query) => {
  const keys = Object.keys(twConfig.theme.screens);
  const nextBreakpoint = keys[keys.indexOf(query) + 1];
  return getBreakpoint(nextBreakpoint);
};

export const useTailwindMediaQuery = (query) => {
  const breakpoint = getBreakpoint(query);

  return useMediaQuery({ maxWidth: breakpoint });
};

export const groupArrayTo = (n, data) => {
  let result = [];
  for (let i = 0; i < data.length; i += n) result.push(data.slice(i, i + n));
  return result;
};

export var checkMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function () {
    return (
      checkMobile.Android() ||
      checkMobile.BlackBerry() ||
      checkMobile.iOS() ||
      checkMobile.Opera() ||
      checkMobile.Windows()
    );
  }
};

export const convertVariables = (data) => {
  if (!data || typeof data !== 'object') return;

  const s3Prefix = 'https://fa-ecom.s3.eu-west-2.amazonaws.com/';
  const newPrefix = 'https://www.sevenstore.com/images/src/';
  const stack = [data];

  while (stack.length) {
    const current = stack.pop();

    for (const [key, val] of Object.entries(current)) {
      if (val == null) continue;
      const isObject = typeof val === 'object';
      const isString = typeof val === 'string';

      if (isString) {
        const lower = val.toLowerCase();

        if (lower === 'true' || lower === 'false') {
          current[key] = lower === 'true';
          continue;
        }

        if (lower === '') {
          current[key] = null;
          continue;
        }

        if (val.includes(s3Prefix)) {
          current[key] = val.replace(s3Prefix, newPrefix);
          continue;
        }
      }
      if (isObject) {
        stack.push(val);
      }
    }
  }
};

export const ppHeadingOverridesOpen = () => {
  const headerElement = document.querySelector('header');
  const mainElement = document.querySelector('.main');
  const navElement = document.getElementById('nav-level0');
  const gpsElemet = document.getElementById('globalStripWrapper');

  if (headerElement) headerElement.classList.add('header-override');
  if (mainElement) mainElement.classList.add('main-override');
  if (navElement) navElement.classList.add('nav-level0-override');
  if (gpsElemet) gpsElemet.classList.add('gps-override');
};

export const ppHeadingOverridesClose = () => {
  const headerElement = document.querySelector('header');
  const mainElement = document.querySelector('.main');
  const navElement = document.getElementById('nav-level0');
  const gpsElemet = document.getElementById('globalStripWrapper');

  if (headerElement) headerElement.classList.remove('header-override');
  if (mainElement) mainElement.classList.remove('main-override');
  if (navElement) navElement.classList.remove('nav-level0-override');
  if (gpsElemet) gpsElemet.classList.remove('gps-override');
};

export const brandUrl = (brandName) => {
  return (
    brandName
      // Breaking up '.replace' for easier reading
      .replace(/\s+/g, '-') // Replace space(s) with hyphen
      .replace(/\.|&/g, '') // Remove '.' / '&' symbol
      .replace(/--+/g, '-') // Replace multiple hyphen's with one
      .replace(/(^-+|-+$)/g, '') // Remove extra hyphen from beginning / end
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/\+/g, '--') // Replace '+' with '--'
      .toLowerCase()
  );
};
